import { styled } from '@mui/material/styles';
import { Chip } from '../chip';

export const StyledTag = styled(Chip)<{ fullWidth?: boolean }>`
  width: ${(p) => (p.fullWidth ? '100%' : 'initial')};
`;
